import React from "react"

/**
 * Shared red asterisk for config labels that display a required indication; required-field validation is enforced independently.
 */
export const RequiredMarker: React.FC = () => (
  <span className="text-coval-danger-text" aria-hidden="true">
    {" "}
    *
  </span>
)
